<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Automatic Store Name Fixer for GREVEXA
setInterval(function() {
    if (document.title !== "GREVEXA") {
        document.title = "GREVEXA";
    }
}, 100);